import {
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";

import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

@Injectable()
export class SetInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    // skip auth token for currents api
    if (req.url.includes("currentsapi.services")) {
      return next.handle(req);
    }

    const clonedReq = this.handleRequest(req);

    return next.handle(clonedReq);
  }

  handleRequest(req: HttpRequest<unknown>) {
    const storageKey = localStorage.getItem(environment.storageKey);

    const token: string | null = storageKey ? storageKey : null;

    let authReq;

    authReq = req.clone({
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        authorization: req.url.includes("/auth/login")
          ? ""
          : token
            ? `Bearer ${token}`
            : "",
      }),
    });

    if (
      (req.method.toLowerCase() === "post" ||
        req.method.toLowerCase() === "put") &&
      req.body instanceof FormData
    ) {
      authReq = req.clone({
        headers: new HttpHeaders({
          authorization: token ? `Bearer ${token}` : "",
        }),
      });
    }

    return authReq;
  }
}
